import { cn } from "../../utils";
import { DividerProps } from "./types";

export const Divider = ({
  text,
  direction = "horizontal",
  className,
  textClassName,
  ...props
}: DividerProps) => {
  const isHorizontal = direction === "horizontal";

  const rootClass: string = cn(
    "relative shrink-0 bg-neutral-500/10",
    isHorizontal ? "w-full h-px" : "w-px h-full",
    className,
  );

  const textClass = cn(
    "text-sm",
    "absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2",
    "px-3 bg-white text-neutral-500",
    textClassName,
  );

  return (
    <div
      className={rootClass}
      role="separator"
      aria-orientation={direction}
      {...props}
    >
      {text && <span className={textClass}>{text}</span>}
    </div>
  );
};
